import { Checkbox } from "@/components/ui/checkbox";
import { tituloDeCapitalizacaoLower } from "@/utils/copyTituloBilhete";

interface FinalizarCompraTermosProps {
    termosAceito: boolean,
    aceitarTermos: (aceitouTermos: boolean) => {}
}

export function FinalizarCompraTermos(props: FinalizarCompraTermosProps) {
    let termos: string = ''

    switch (import.meta.env.VITE_APP_THEME) {
        case 'AcreCap':
            termos = `Estou ciente que a aquisição deste ${tituloDeCapitalizacaoLower()} implica automática adesão às condições gerais recebidas, ciência dos seus termos e a cessão do direito de resgate à APAE BRASIL, com o que concordo espontaneamente`;
            break;
        case 'MegaCap':
            termos = 'Concordo com os termos e condições disponível do site';
            break;
        case 'RondonCap':
            termos = `Estou ciente que a aquisição deste ${tituloDeCapitalizacaoLower()} implica automática adesão às condições gerais recebidas, ciência dos seus termos e a cessão do direito de resgate à FEAPAES - RO, com o que concordo espontaneamente.`;
            break;
        case 'RoraiCap':
            termos = `Estou ciente que a aquisição deste ${tituloDeCapitalizacaoLower()} implica automática adesão às condições gerais recebidas, ciência dos seus termos e a cessão do direito de resgate à FEDERAÇÃO NACIONAL DAS APAES - FENAPAES, com o que concordo espontaneamente.`;
            break;
    }


    return (
        <div className="flex items-center space-x-2 mt-5">
            <Checkbox checked={props.termosAceito} onCheckedChange={props.aceitarTermos} id="termos" />
            <label
                htmlFor="termos"
                className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
                {termos}
            </label>
        </div>
    )
}